import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/withRouter';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import _ from 'lodash';

import Header from '../../../components/Header/Header';
import { updateStepData } from '../AddonActions';
import { DigitalPlans, Confirmation } from '../components';

import { getCustomerBilling } from '../../Billing/BillingActions';

import '../Addon.scss';

class DigitalUpgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1
    };
  }

  componentDidMount() {
    if (!this.props.customer.plan) {
      this.props.getCustomerBilling();
    } else {
      this.setModel();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customer != this.props.customer) {
      this.setModel();
    }
  }

  componentWillUnmount() {
    this.props.updateStepData({});
  }

  setModel() {
    const model = {
      currentAddon: this.props.customer.addon? this.props.customer.addon.id: undefined,
      planId: this.props.customer.subscription.plan_id,
      firstName: this.props.customer.customer.billing_address.first_name,
      lastName: this.props.customer.customer.billing_address.last_name,
      country: this.props.customer.customer.billing_address.country,
      company: this.props.customer.customer.billing_address.company,
      coupon: this.props.customer.subscription.coupon
    };

    if (this.props.customer.card) {
      model.card = {
        lastFour: this.props.customer.card.last4,
        cardType: this.props.customer.card.card_type
      };
    }

    this.props.updateStepData(model);
  }

  render() {
    const { step } = this.state;

    return (
      <div>
        <Helmet>
          <title>{pageTitle('Billing')}</title>
        </Helmet>
        <Header showHome={true} buttons={[]} />
        <div className='subscribe_content'>
          <div className='indicator'>
            <div className={`item ${step > 1 && 'passed'} ${step < 2 && 'active'}`}>
              <span className='number'>1</span> Select plan
            </div>
            <div className={`item ${step === 2 && 'active' }`}><span className='number'>2</span> Confirm subscription</div>
          </div>
          {step === 1 && <DigitalPlans isAnnual={this.props.customer.subscription ? this.props.customer.subscription.plan_id.indexOf('annual') > -1: true} onNext={step => this.setState({ step })} />}          
          {step === 2 && <Confirmation isUpgrade={false} onBack={() => this.setState({ step: 1 })} />}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateStepData: model => dispatch(updateStepData(model)),
    getCustomerBilling: () => dispatch(getCustomerBilling())
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    outside: state.app.outside,
    reqSent: state.subscription.sent,
    customer: state.billing.customer,
    user: state.auth.user
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigitalUpgrade));
